import { render } from "./vehicle-specification.vue?vue&type=template&id=1cc2a5b0"
import script from "./vehicle-specification.vue?vue&type=script&lang=js"
export * from "./vehicle-specification.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__